import React from 'react';
import { Typography, Button } from '@mui/material';
import TextLanguage from '../../../data/TextLanguage.json';


import FileDownload from '@mui/icons-material/FileDownload';
import { useDownloadBatchFileMutation } from '../../../hooks/useDownloadBatchFileMutation';


export const downloadFileButtonTemplate = (lang, filetype, setLDMFilteredPatientList, setsnackbarStatus) => (data, index) => {

    const downloadBatchFileMutation = useDownloadBatchFileMutation({ setsnackbarStatus });




    const buttonClickHandler = (event) => {
        event.preventDefault();

        setLDMFilteredPatientList(prevList => prevList.map(item => {
            return (item.entryName === data.entryName) ?
                {
                    entryName: item.entryName,
                    caseArray: item.caseArray,
                    Downloaded: true
                }
                :
                item

        }
        ));

        const updaterData = {
            caseNumberArray: data.caseArray
        }
        downloadBatchFileMutation.mutate({ updaterData });
    };


    return (<Button key={`downloadInvoiceButton-${data?.entryName}-${index}`} className='DocDownloadButton'
        onClick={buttonClickHandler}
        disabled={downloadBatchFileMutation.isLoading || downloadBatchFileMutation.isSuccess}
        disableRipple={true}
        sx={{
            width: '100%', height: 'auto', minWidth: '40px', minHeight: '25px', p: '0.25rem', m: '0px',
            borderRadius: '0px',
            background: data.Downloaded ? 'var(--color-light3)' : 'var(--color-success-dark)',
            border: '1px solid var(--color-light3)',
            boxShadow: 'none',
            '&:hover': {
                background:  data.Downloaded ? 'var(--color-light3)' : 'var(--color-success-dark)',
                boxShadow: 'none',
                outline: 'none',
                border: '1px solid var(--color-success-light)',
            }
        }}
    >
        <FileDownload htmlColor='white' sx={{ width: '25px', height: '25px' }} />

    </Button>)
};

//   <Typography>
//             {TextLanguage['Download'][lang]}
//         </Typography>